export type ColorMode = 'light' | 'dark';

export const COLOR_MODE_STORAGE_KEY = 'moonitor-color-mode';
